<div class="blog-with-tag-main" *ngIf="dataIsReady">
  <div class="top-view">
    <div class="blog-tag-title">{{ tagTitle }}</div>
  </div>
  <div class="back-holder" (click)="closeBlogWithTag()">
    <img src="assets/general/back-blue.svg" />
  </div>
  <div class="top-view-shadow"></div>
  <!-- <div *ngIf="!notFound" class="creator-holder">
    <div class="logo-holder">
      <img *ngIf="posts[0].user.avatarPath !== ''" src={{posts[0].user.avatarPath}} onerror="this.onerror=null; this.src='assets/blog/avatar.svg'">
      <img *ngIf="posts[0].user.avatarPath === ''" src="assets/blog/avatar.svg">
    </div>
    <div class="creator-title">{{posts[0].user.userName}}</div>
  </div> -->
  <div
    *ngIf="!notFound"
    class="mid-view"
    #scrollTopBlogWithTag
    (scroll)="scroll(false, false)"
  >
    <ul style="margin: 0; padding: 0">
      <li
        *ngFor="let post of posts; let i = index"
        [ngStyle]="{ 'margin-top': i === 0 ? '16px' : '0' }"
      >
        <app-post
          [id]="id"
          [post]="post"
          [username]="myUsername"
          [loadImage]="loadImage[i]"
          class="appPostBlogWithTag"
        ></app-post>
      </li>
    </ul>
    <div class="more-posts" *ngIf="postsCount > (postsPage + 1) * 10">
      <div class="more-posts-title" (click)="showMorePosts()">
        پست‌های بیشتر
      </div>
    </div>
  </div>
  <div *ngIf="notFound" class="not-found">
    پستی برای {{ tagTitle }} یافت نشد.
  </div>
</div>
<div class="botomsheet" attr.id="botomsheet{{ id }}" *ngIf="showDetail">
  <app-post-detail
    [id]="detailId"
    [post]="selectedPost"
    style="width: 100%; height: 100%"
  ></app-post-detail>
  <div class="close" (click)="closeDetail()">بستن</div>
</div>
<div class="search-page" id="blogWithTag{{ id }}" *ngIf="showBlogWithTag">
  <app-blog-with-tag
    [id]="tagId"
    style="width: 100%; height: 100%"
  ></app-blog-with-tag>
  <div class="blog-with-tag-back-holder" (click)="closeBlogWithTag()">
    <img src="assets/general/back-blue.svg" />
  </div>
</div>
